<template>
  <router-view />
</template>

<script>
import mixin, { unRegisterMixin } from '@/mixin/storeGenerator';

export default {
  name: 'WrapperAppointment',
  mixins: [mixin, unRegisterMixin],
  data() {
    return {
      moduleName: 'appointmentModule',
    };
  },
};
</script>
